<template>
  <div class="commlist">
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <template v-if="List_info.channelId">
          <transition-group name="van2-slide-right">
            <CommonItem
              v-for="item in List_info.list"
              :key="item.id"
              :article_info="item"
            >
            </CommonItem>
          </transition-group>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  computed,
  provide,
  inject,
  watchEffect,
  watch,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import CommonItem from "./CommonItem";

export default {
  props: {
    tagsInfo: Object,
    index: Number,
  },
  components: {
    CommonItem,
  },
  setup(props) {
    // vuex
    const store = useStore();

    const { index } = toRefs(props);

    provide("index", index);

    const active = inject("active", 0);

    // 获取列表
    // 使用computed包裹以后都需要使用.value来获取值
    // 包括对象本身
    const List_info = computed(() => {
      const temp = store.state.list_info.find(
        (e) => e.channelId == props.tagsInfo.tags_id
      );
      if (temp) {
        return temp;
      } else {
        return {};
      }
    });

    const state = reactive({
      loading: false,
      finished: false,
      refreshing: false,
    });

    // 加载数据
    const onLoad = (fresh = false) => {
      console.log("触发底部加载c", state.loading, index.value, active.value);

      if (index.value == active.value) {
        if (fresh) {
          state.loading = true;
          state.refreshing = true;
          store
            .dispatch("getListData", {
              channelId: props.tagsInfo.tags_id,
              page: 1,
            })
            .then(() => {
              state.loading = false;
              state.refreshing = false;
            });

          return;
        }

        // 如果page等于totalpage的话说明已经加载结束了
        // 这里有个情况就是List_info.value.page和 List_info.value.totalPage
        // 会出现都是undefined的情况
        // TODO:将这里处理的更优雅些
        if (List_info.value.page == List_info.value.totalPage) {
          if (List_info.value.page && List_info.value.totalPage) {
            state.finished = true;
          }
        } else {
          state.loading = true;
          store
            .dispatch("getListData", {
              channelId: props.tagsInfo.tags_id,
              page: List_info.value.page + 1,
            })
            .then(() => {
              state.loading = false;
            });
        }
      }
    };

    const onRefresh = () => {
      onLoad(true);
    };

    // 这里是固定index因为每个组件的index都是固定的
    const true_index = index.value;
    // 思路就是，通过监听active.value的变化
    //如果active变化的话，开始对比是否有值，如果没有值的话，就开始请求
    // 大幅提升性能
    watchEffect(() => {
      console.log("触发effect_c");
      // 如果active和index一样的时候
      if (active.value == true_index) {
        // 如果为false的话，说明还没有数据，开始请求
        if (!List_info.value.channelId) {
          console.log("加载内页");
          onLoad(true);
        }
      }
    });

    // 观测active的变动
    // 这个处理的是，防止被其他组件影响state的loading
    watch(active, () => {
      if (active.value != true_index) {
        // 如果未完成
        if (!state.finished) {
          //检测是否再加载当中,避免边际影响
          if (state.loading) {
            state.loading = false;
          }
        }
      }
    });

    return {
      state,
      onLoad,
      onRefresh,
      List_info,
    };
  },
};
</script>


<style>
.van2-slide-right-enter-active {
  animation: van-fade-in 1s both ease-out;
}
.van2-slide-right-leave-active {
  animation: van-fade-out 0.2s both ease-in;
}
</style>